export default [
  {
    ref: 'seccion-juego',
    name: 'juego',
    type: 'game',
    dictionary: 'LOCALE.GAME',
  },
  {
    ref: 'seccion-personajes',
    name: 'personajes',
    type: 'characters',
    dictionary: 'LOCALE.CHARACTERES',
  },
  {
    ref: 'seccion-classificacao',
    name: 'clasificación',
    type: 'ranking',
    dictionary: 'LOCALE.RANKING',
  },
  {
    ref: 'seccion-pelicula',
    name: 'pelicula',
    type: 'trailer',
    dictionary: 'LOCALE.VIDEO',
  },
  {
    ref: 'seccion-capturas',
    name: 'capturas',
    type: 'screenshots',
    dictionary: 'LOCALE.SCREENSHOT',
  },
  {
    ref: 'seccion-social',
    name: 'social',
    type: 'social',
    href: '/',
    dictionary: 'LOCALE.SOCIAL',
  },
];
